<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Dashboard</h1>

    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <div class="p-8 m-6">
        <p class="mb-8 leading-normal">
        <div>
          <br /><b>PRODOTTI VENDUTI:</b> <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          <b>{{ todayMinus6 }}: {{ countProductsSalesTodayMinus6 }} per un valore di: {{
            priceSalesTodayMinus6.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} </b><br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 1 - Salvatore: {{ countProductsSalesTodayMinus6Shop1 }} per un valore di: {{
            priceSalesTodayMinus6Shop1.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 2 - Daniele: {{ countProductsSalesTodayMinus6Shop2 }} per un valore di: {{
            priceSalesTodayMinus6Shop2.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 3 - Andria: {{ countProductsSalesTodayMinus6Shop3 }} per un valore di: {{
            priceSalesTodayMinus6Shop3.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 4 - Sabino: {{ countProductsSalesTodayMinus6Shop4 }} per un valore di: {{
            priceSalesTodayMinus6Shop4.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 5 - Roma: {{ countProductsSalesTodayMinus6Shop5 }} per un valore di: {{
            priceSalesTodayMinus6Shop5.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 6: {{ countProductsSalesTodayMinus6Shop6 }} per un valore di: {{
            priceSalesTodayMinus6Shop6.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          <br /><b>{{ todayMinus5 }}: {{ countProductsSalesTodayMinus5 }} per un valore di: {{
            priceSalesTodayMinus5.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} </b><br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 1 - Salvatore: {{ countProductsSalesTodayMinus5Shop1 }} per un valore di: {{
            priceSalesTodayMinus5Shop1.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 2 - Daniele: {{ countProductsSalesTodayMinus5Shop2 }} per un valore di: {{
            priceSalesTodayMinus5Shop2.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 3 - Andria: {{ countProductsSalesTodayMinus5Shop3 }} per un valore di: {{
            priceSalesTodayMinus5Shop3.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 4 - Sabino: {{ countProductsSalesTodayMinus5Shop4 }} per un valore di: {{
            priceSalesTodayMinus5Shop4.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 5 - Roma: {{ countProductsSalesTodayMinus5Shop5 }} per un valore di: {{
            priceSalesTodayMinus5Shop5.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 6: {{ countProductsSalesTodayMinus5Shop6 }} per un valore di: {{
            priceSalesTodayMinus5Shop6.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>

        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          <br /><b>{{ todayMinus4 }}: {{ countProductsSalesTodayMinus4 }} per un valore di: {{
            priceSalesTodayMinus4.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} </b><br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 1 - Salvatore: {{ countProductsSalesTodayMinus4Shop1 }} per un valore di: {{
            priceSalesTodayMinus4Shop1.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 2 - Daniele: {{ countProductsSalesTodayMinus4Shop2 }} per un valore di: {{
            priceSalesTodayMinus4Shop2.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 3 - Andria: {{ countProductsSalesTodayMinus4Shop3 }} per un valore di: {{
            priceSalesTodayMinus4Shop3.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 4 - Sabino: {{ countProductsSalesTodayMinus4Shop4 }} per un valore di: {{
            priceSalesTodayMinus4Shop4.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 5 - Roma: {{ countProductsSalesTodayMinus4Shop5 }} per un valore di: {{
            priceSalesTodayMinus4Shop5.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 6: {{ countProductsSalesTodayMinus4Shop6 }} per un valore di: {{
            priceSalesTodayMinus4Shop6.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>

        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          <br /><b>{{ todayMinus3 }}: {{ countProductsSalesTodayMinus3 }} per un valore di: {{
            priceSalesTodayMinus3.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} </b><br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 1 - Salvatore: {{ countProductsSalesTodayMinus3Shop1 }} per un valore di: {{
            priceSalesTodayMinus3Shop1.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 2 - Daniele: {{ countProductsSalesTodayMinus3Shop2 }} per un valore di: {{
            priceSalesTodayMinus3Shop2.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 3 - Andria: {{ countProductsSalesTodayMinus3Shop3 }} per un valore di: {{
            priceSalesTodayMinus3Shop3.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 4 - Sabino: {{ countProductsSalesTodayMinus3Shop4 }} per un valore di: {{
            priceSalesTodayMinus3Shop4.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 5 - Roma: {{ countProductsSalesTodayMinus3Shop5 }} per un valore di: {{
            priceSalesTodayMinus3Shop5.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 6: {{ countProductsSalesTodayMinus3Shop6 }} per un valore di: {{
            priceSalesTodayMinus3Shop6.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>

        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          <br /><b>{{ todayMinus2 }}: {{ countProductsSalesTodayMinus2 }} per un valore di: {{
            priceSalesTodayMinus2.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} </b><br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 1 - Salvatore: {{ countProductsSalesTodayMinus2Shop1 }} per un valore di: {{
            priceSalesTodayMinus2Shop1.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 2 - Daniele: {{ countProductsSalesTodayMinus2Shop2 }} per un valore di: {{
            priceSalesTodayMinus2Shop2.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 3 - Andria: {{ countProductsSalesTodayMinus2Shop3 }} per un valore di: {{
            priceSalesTodayMinus2Shop3.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 4 - Sabino: {{ countProductsSalesTodayMinus2Shop4 }} per un valore di: {{
            priceSalesTodayMinus2Shop4.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 5 - Roma: {{ countProductsSalesTodayMinus2Shop5 }} per un valore di: {{
            priceSalesTodayMinus2Shop5.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 6: {{ countProductsSalesTodayMinus2Shop6 }} per un valore di: {{
            priceSalesTodayMinus2Shop6.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>

        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          <br /><b>{{ todayMinus1 }}: {{ countProductsSalesTodayMinus1 }} per un valore di: {{
            priceSalesTodayMinus1.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} </b><br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 1 - Salvatore: {{ countProductsSalesTodayMinus1Shop1 }} per un valore di: {{
            priceSalesTodayMinus1Shop1.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 2 - Daniele: {{ countProductsSalesTodayMinus1Shop2 }} per un valore di: {{
            priceSalesTodayMinus1Shop2.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 3 - Andria: {{ countProductsSalesTodayMinus1Shop3 }} per un valore di: {{
            priceSalesTodayMinus1Shop3.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 4 - Sabino: {{ countProductsSalesTodayMinus1Shop4 }} per un valore di: {{
            priceSalesTodayMinus1Shop4.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 5 - Roma: {{ countProductsSalesTodayMinus1Shop5 }} per un valore di: {{
            priceSalesTodayMinus1Shop5.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          Cassa 6: {{ countProductsSalesTodayMinus1Shop6 }} per un valore di: {{
            priceSalesTodayMinus1Shop6.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>

        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          <br /><b>{{ today }}: {{ countProductsSalesToday }} per un valore di: {{ priceSalesToday.toLocaleString('it-IT',
            {
              style: 'currency', currency: 'EUR'
            }) }} </b><br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25 || user.id == 5">
          Cassa 1 - Salvatore: {{ countProductsSalesTodayShop1 }} per un valore di: {{ priceSalesTodayShop1.toLocaleString('it-IT', {
            style: 'currency', currency: 'EUR'
          }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25 || user.id == 6">
          Cassa 2 - Daniele: {{ countProductsSalesTodayShop2 }} per un valore di: {{ priceSalesTodayShop2.toLocaleString('it-IT', {
            style: 'currency', currency: 'EUR'
          }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25 || user.id == 7">
          Cassa 3 - Andria: {{ countProductsSalesTodayShop3 }} per un valore di: {{ priceSalesTodayShop3.toLocaleString('it-IT', {
            style: 'currency', currency: 'EUR'
          }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25 || user.id == 8">
          Cassa 4 - Sabino: {{ countProductsSalesTodayShop4 }} per un valore di: {{ priceSalesTodayShop4.toLocaleString('it-IT', {
            style: 'currency', currency: 'EUR'
          }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25 || user.id == 9">
          Cassa 5 - Roma: {{ countProductsSalesTodayShop5 }} per un valore di: {{ priceSalesTodayShop5.toLocaleString('it-IT', {
            style: 'currency', currency: 'EUR'
          }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25 || user.id == 10">
          Cassa 6: {{ countProductsSalesTodayShop6 }} per un valore di: {{ priceSalesTodayShop6.toLocaleString('it-IT', {
            style: 'currency', currency: 'EUR'
          }) }} <br />
        </div>

        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          <br /><b>TOTALE ULTIMI 7 GIORNI:</b> {{ countTotalProductsSales }} per un valore di: {{
            totalPriceSales.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) }} <br />
        </div>
        <div v-if="user.id == 18 || user.id == 1 || user.id == 24 || user.id == 25">
          <br /><br /><b>UTENTI ISCRITTI:</b> {{ countTotalCustomers }}<br />

          <ul>
            <li v-for="(item, key) in countCityCustomers13_14_15" v-bind:key>
              {{ item.city }} {{ item.total }}<br />
            </li>
          </ul>
        </div>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
  computed: {
    user() {
      return this.$page.props.auth.user
    },
  },
  metaInfo: { title: 'Dashboard' },
  layout: Layout,
  props: ['countTotalCustomers', 'countCityCustomers13_14_15',

    'priceSalesToday', 'priceSalesTodayShop1', 'priceSalesTodayShop2', 'priceSalesTodayShop3', 'priceSalesTodayShop4', 'priceSalesTodayShop5', 'priceSalesTodayShop6',
    'priceSalesTodayMinus1', 'priceSalesTodayMinus1Shop1', 'priceSalesTodayMinus1Shop2', 'priceSalesTodayMinus1Shop3', 'priceSalesTodayMinus1Shop4', 'priceSalesTodayMinus1Shop5', 'priceSalesTodayMinus1Shop6',
    'priceSalesTodayMinus2', 'priceSalesTodayMinus2Shop1', 'priceSalesTodayMinus2Shop2', 'priceSalesTodayMinus2Shop3', 'priceSalesTodayMinus2Shop4', 'priceSalesTodayMinus2Shop5', 'priceSalesTodayMinus2Shop6',
    'priceSalesTodayMinus3', 'priceSalesTodayMinus3Shop1', 'priceSalesTodayMinus3Shop2', 'priceSalesTodayMinus3Shop3', 'priceSalesTodayMinus3Shop4', 'priceSalesTodayMinus3Shop5', 'priceSalesTodayMinus3Shop6',
    'priceSalesTodayMinus4', 'priceSalesTodayMinus4Shop1', 'priceSalesTodayMinus4Shop2', 'priceSalesTodayMinus4Shop3', 'priceSalesTodayMinus4Shop4', 'priceSalesTodayMinus4Shop5', 'priceSalesTodayMinus4Shop6',
    'priceSalesTodayMinus5', 'priceSalesTodayMinus5Shop1', 'priceSalesTodayMinus5Shop2', 'priceSalesTodayMinus5Shop3', 'priceSalesTodayMinus5Shop4', 'priceSalesTodayMinus5Shop5', 'priceSalesTodayMinus5Shop6',
    'priceSalesTodayMinus6', 'priceSalesTodayMinus6Shop1', 'priceSalesTodayMinus6Shop2', 'priceSalesTodayMinus6Shop3', 'priceSalesTodayMinus6Shop4', 'priceSalesTodayMinus6Shop5', 'priceSalesTodayMinus6Shop6',
    'totalPriceSales',

    'countProductsSalesToday', 'countProductsSalesTodayShop1', 'countProductsSalesTodayShop2', 'countProductsSalesTodayShop3', 'countProductsSalesTodayShop4', 'countProductsSalesTodayShop5', 'countProductsSalesTodayShop6',
    'countProductsSalesTodayMinus1', 'countProductsSalesTodayMinus1Shop1', 'countProductsSalesTodayMinus1Shop2', 'countProductsSalesTodayMinus1Shop3', 'countProductsSalesTodayMinus1Shop4', 'countProductsSalesTodayMinus1Shop5', 'countProductsSalesTodayMinus1Shop6',
    'countProductsSalesTodayMinus2', 'countProductsSalesTodayMinus2Shop1', 'countProductsSalesTodayMinus2Shop2', 'countProductsSalesTodayMinus2Shop3', 'countProductsSalesTodayMinus2Shop4', 'countProductsSalesTodayMinus2Shop5', 'countProductsSalesTodayMinus2Shop6',
    'countProductsSalesTodayMinus3', 'countProductsSalesTodayMinus3Shop1', 'countProductsSalesTodayMinus3Shop2', 'countProductsSalesTodayMinus3Shop3', 'countProductsSalesTodayMinus3Shop4', 'countProductsSalesTodayMinus3Shop5', 'countProductsSalesTodayMinus3Shop6',
    'countProductsSalesTodayMinus4', 'countProductsSalesTodayMinus4Shop1', 'countProductsSalesTodayMinus4Shop2', 'countProductsSalesTodayMinus4Shop3', 'countProductsSalesTodayMinus4Shop4', 'countProductsSalesTodayMinus4Shop5', 'countProductsSalesTodayMinus4Shop6',
    'countProductsSalesTodayMinus5', 'countProductsSalesTodayMinus5Shop1', 'countProductsSalesTodayMinus5Shop2', 'countProductsSalesTodayMinus5Shop3', 'countProductsSalesTodayMinus5Shop4', 'countProductsSalesTodayMinus5Shop5', 'countProductsSalesTodayMinus5Shop6',
    'countProductsSalesTodayMinus6', 'countProductsSalesTodayMinus6Shop1', 'countProductsSalesTodayMinus6Shop2', 'countProductsSalesTodayMinus6Shop3', 'countProductsSalesTodayMinus6Shop4', 'countProductsSalesTodayMinus6Shop5', 'countProductsSalesTodayMinus6Shop6',
    'countTotalProductsSales',

    'today', 'todayMinus1', 'todayMinus2', 'todayMinus3', 'todayMinus4', 'todayMinus5', 'todayMinus6',
  ],

  data() {
    return {}
  },
}
</script>
